export enum SortDataType {
    string,
    number
}
